import { Box } from '@mui/material';
import React from 'react';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';

import {
  featuresImageColSx,
  featuresImageSx,
  featuresRowSx,
  featuresSectionSx,
  featuresTextColSx,
  marketingContainerSx,
} from '../../homeSsrStyles';

import Channels from './images/channels.png';
import Channels2x from './images/channels@2x.png';
import MultiLanguage from './images/multi-language.png';
import MultiLanguage2x from './images/multi-language@2x.png';
import NoCode from './images/no-code.png';
import NoCode2x from './images/no-code@2x.png';
import RealTime from './images/real-time.png';
import RealTime2x from './images/real-time@2x.png';
import UploadCSV from './images/upload-csv.png';
import UploadCSV2x from './images/upload-csv@2x.png';

const messages = defineMessages({
  multiLanguageAlt: { id: 'Features.MultiLanguageAlt', defaultMessage: 'Multi Language' },
  noCodeAlt: { id: 'Features.NoCodeAlt', defaultMessage: 'Without coding' },
  uploadAlt: { id: 'Features.UploadAlt', defaultMessage: 'Upload CSV' },
  realTimeAlt: { id: 'Features.RealTimeAlt', defaultMessage: 'Real time analytics' },
  channelsAlt: { id: 'Features.Channels', defaultMessage: 'Multi-channel' },
});

function FeatureRow({ reverse, title, description, image, image2x, alt }) {
  return (
    <Box sx={featuresRowSx(reverse)}>
      <Box sx={featuresTextColSx}>
        <Box component="h3">{title}</Box>
        <Box component="p">{description}</Box>
      </Box>
      <Box sx={featuresImageColSx}>
        <Box
          component="img"
          src={image}
          srcSet={`${image} 400w, ${image2x} 800w`}
          alt={alt}
          sx={featuresImageSx}
        />
      </Box>
    </Box>
  );
}

function Features(props) {
  const { formatMessage } = props.intl;

  return (
    <Box component="section" sx={featuresSectionSx} id="features1-5">
      <Box sx={marketingContainerSx}>
        <FeatureRow
          title={
            <FormattedMessage
              id="Features.MultiLanguageTitle"
              defaultMessage="Send NPS surveys in multiple languages."
            />
          }
          description={
            <FormattedMessage
              id="Features.MultiLanguageDescription"
              defaultMessage="Your customers will answer the NPS question in their native language. Add their prefered language to your CSV and Promoter Ninja will do the rest."
            />
          }
          image={MultiLanguage}
          image2x={MultiLanguage2x}
          alt={formatMessage(messages.multiLanguageAlt)}
        />
        <FeatureRow
          reverse
          title={
            <FormattedMessage
              id="Features.FullyCodeFreeTitle"
              defaultMessage="Fully Code-Free Customized"
            />
          }
          description={
            <FormattedMessage
              id="Features.FullyCodeFreeDescription"
              defaultMessage="Add your logo and pick your colours to customize your NPS survey e-mail within the Promoter Ninja app, no coding knowledge required."
            />
          }
          image={NoCode}
          image2x={NoCode2x}
          alt={formatMessage(messages.noCodeAlt)}
        />
        <FeatureRow
          title={
            <FormattedMessage
              id="Features.EasyImportTitle"
              defaultMessage="Import your data easily"
            />
          }
          description={
            <FormattedMessage
              id="Features.EasyImportDescription"
              defaultMessage="Upload your contacts with a simple CSV. Add as much columns as you need to further filter the results based on your own segmentation criteria."
            />
          }
          image={UploadCSV}
          image2x={UploadCSV2x}
          alt={formatMessage(messages.uploadAlt)}
        />
        <FeatureRow
          reverse
          title={
            <FormattedMessage
              id="Features.RealTimeAnalyticsTitle"
              defaultMessage="Analyze responses in real time"
            />
          }
          description={
            <FormattedMessage
              id="Features.RealTimeAnalyticsDescription"
              defaultMessage="Get immediate feedback from your customers. Gather your NPS score plus the answers to your open-ended questions and filter them in real time."
            />
          }
          image={RealTime}
          image2x={RealTime2x}
          alt={formatMessage(messages.realTimeAlt)}
        />
        <FeatureRow
          title={
            <FormattedMessage
              id="Features.MultiChannelTitle"
              defaultMessage="Multi-channel surveys"
            />
          }
          description={
            <FormattedMessage
              id="Features.MultichannelDescription"
              defaultMessage="Survey your customers directly on your website or send surveys via email or SMS."
            />
          }
          image={Channels}
          image2x={Channels2x}
          alt={formatMessage(messages.channelsAlt)}
        />
      </Box>
    </Box>
  );
}

export default injectIntl(Features);
